import { off, on } from '@/utils/evenListening'
import { useEffect, useState } from 'react'

const OFFSET = 20

export default function useScrollSideX (scrollingRef) {
  const [isStartSide, setIsStart] = useState(true)
  const [isEndSide, setIsEnd] = useState(false)

  useEffect(() => {
    const element = scrollingRef.current
    if (!element) return

    const computeCall = () => {
      setIsStart(element.scrollLeft < OFFSET)
      setIsEnd(element.scrollLeft + element.clientWidth > element.scrollWidth - OFFSET)
    }

    on(element, 'scroll', computeCall, { passive: true })
    on(window, 'resize', computeCall)

    return () => {
      off(element, 'scroll', computeCall, { passive: true })
      off(window, 'resize', computeCall)
    }
  }, [scrollingRef])

  return {
    isStartSide,
    isEndSide
  }
}
